import { Box, Button, FlexBox, Icon, Typography } from '@vp/swan';

export interface MaxMessagesReachedCardProps {
    onReview: () => void;
}

export function MaxMessagesReachedCard({ onReview }: MaxMessagesReachedCardProps) {
    return (
        <Box
            style={{
                backgroundColor: 'var(--swan-sem-color-bg-active)',
                border: '1px solid var(--swan-sem-color-border-standard)',
                borderBottom: 'none',
                padding: 'var(--swan-sem-space-6)',
                borderRadius:
                    'var(--swan-sem-border-radius-standard) var(--swan-sem-border-radius-standard) 0 0',
            }}
        >
            <FlexBox alignItems="center" gap={3} mb={5}>
                <Icon iconType="polish" size="standard" skin="accent" />
                <Typography fontSkin="title-item">Almost there...</Typography>
            </FlexBox>
            <Box as="ul" style={{ margin: 0, paddingLeft: 'var(--swan-sem-space-5)' }}>
                <Typography as="li" fontSkin="body-standard" mb={2}>
                    There are a few details left to fill in
                </Typography>
                <Typography as="li" fontSkin="body-standard" mb={2}>
                    You can complete them on the review page
                </Typography>
                <Typography as="li" fontSkin="body-standard" mb={5}>
                    Once you submit, a designer will start working on your design
                </Typography>
            </Box>

            <Button skin="primary" iconPosition="left" onClick={onReview}>
                <Icon iconType="edit" size="small" />
                Review your brief
            </Button>
        </Box>
    );
}
